import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { ITextRow } from '../../../dashboards/interfaces/tiles/definition-helpers/text-row.interface';
import { ITextRowsTileInstance } from '../../../dashboards/interfaces/tiles/definitions/text-rows-tile-definition.interface';
import { HORIZONTAL_POSITION_OPTIONS } from '../../constants/horizontal-position-options.constant';
import { ISelectOption } from '../../interfaces/select-option.interface';
import { TileCreatorHelpersService } from '../../services/tile-creator-helpers.service';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';
import { TileSetupWizardComponent } from '../tile-setup-wizard.component';

@Component({
  standalone: false,
  selector: 'lib-text-rows-setup-wizard',
  templateUrl: './text-rows-setup-wizard.component.html',
  styleUrls: ['../shared-tile-creator-styles.scss', './text-rows-setup-wizard.component.scss'],
})
export class TextRowsSetupWizardComponent extends TileSetupWizardComponent<ITextRowsTileInstance> {
  textRows;

  horizontalPositionOptions: ISelectOption[];
  fontSizesOptions: string[];

  constructor(
    private readonly fb: FormBuilder,
    private readonly tileCreatorHelpersService: TileCreatorHelpersService,
    private readonly tileCreatorService: TileCreatorService,
  ) {
    super();

    this.tileInstance = inject(TILE_REQUEST).tileInstance;
  }

  ngOnInit() {
    this.initSelectOptions();
    this.initSetupForms();

    this.hookForm();
  }

  initSelectOptions() {
    this.horizontalPositionOptions = HORIZONTAL_POSITION_OPTIONS;
    this.fontSizesOptions = this.tileCreatorHelpersService.generateFontSize();
  }

  initSetupForms() {
    this.setupForm = this.fb.group({
      textRows: this.fb.array([]),
      background: [''],
    });

    if (this.tileInstance) {
      this.setupForm.patchValue(this.tileInstance);

      this.tileInstance.textRows?.forEach((textRow: ITextRow, textRowIndex: number) => {
        this.addTextRow(textRow);
      });
    } else {
      this.addTextRow();
    }

    this.textRows = this.setupForm.controls.textRows;
  }

  addTextRow(textRow?: ITextRow) {
    const textRowFormGroup = this.fb.group({
      heading: [''],
      headingFontSize: ['6px'],
      headingFontColor: ['#000000'],
      text: [''],
      textFontSize: ['6px'],
      textFontColor: ['#000000'],
      img: [''],
      imgPosition: ['start'],
      linkButtons: this.fb.array([]),
    });

    textRowFormGroup.patchValue(textRow);

    (this.setupForm.controls.textRows as FormArray).push(textRowFormGroup);
  }

  removeTextRow(textRowIndex: number) {
    (this.setupForm.controls.textRows as FormArray).removeAt(textRowIndex);
  }

  getLinkButtonsControls(textRowIndex: number) {
    return this.textRows.at(textRowIndex).get('linkButtons') as FormArray;
  }

  onCreate() {
    Object.assign(this.tileInstance, this.getChanges());
    this.tileCreatorService.onChange.next();
  }

  getChanges() {
    return {
      tileType: 'text-rows',
      canView: 'true',
      ...this.setupForm.value,
    };
  }
}
